module.exports = __webpack_public_path__ + "img/katarina_events_11.29717105.jpg";